import { useState } from "react";

const CollapsibleSection = ({ label, defaultOpen = false, children }) => {
    const [open, setOpen] = useState(defaultOpen);
    return (
        <div className="space-y-2">
            <button
                type="button"
                onClick={() => setOpen((v) => !v)}
                className="w-full flex justify-between items-center text-left"
            >
                <span className="text-xs text-white uppercase tracking-wide">{label}</span>
                <svg
                    className={`w-4 h-4 text-zinc-500 transition-transform ${open ? "rotate-90" : ""}`}
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                >
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                </svg>
            </button>
            {open && <div className="space-y-2">{children}</div>}
        </div>
    );
};

export default CollapsibleSection;
